import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {filter, map, takeUntil} from 'rxjs/operators';

@Injectable()
export class UiToPlayableService {
  private uiEvents$ = new Subject();
  private cleanUp$ = new Subject();

  constructor() {
  }

  cleanUp() {
    this.cleanUp$.next();
  }

  onUiEvent(eventType: string) {
    return this.uiEvents$.pipe(
      takeUntil(this.cleanUp$),
      filter((event: any) => event.type === eventType),
      map(event => event.payload)
    );
  }

  emitUIEvent(event) {
    console.log('emitUIEvent', {event});
    this.uiEvents$.next(event);
  }

}
